export function convertCoordToGoogleMapsFormat(
  coord: number[],
): google.maps.LatLngLiteral {
  return {
    lng: coord[0],
    lat: coord[1],
  };
}

export function convertCoordsToGoogleMapsFormat(
  coords: number[][],
): google.maps.LatLngLiteral[] {
  return coords.map((coord) => convertCoordToGoogleMapsFormat(coord));
}

export function parseLatLng(value: string) {
  const match = value
    .trim()
    .match(/^(-?\d+(?:\.\d+)?)\s*(?:,\s*|\s+)(-?\d+(?:\.\d+)?)$/);
  if (!match) return null;
  const lat = parseFloat(match[1]);
  const lng = parseFloat(match[2]);
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
  return { lat, lng };
}

export function validateLatLng(input: string) {
  // Remove any whitespace and split by comma
  const coords = input.replace(/\s/g, '').split(',');

  // Check if we have exactly 2 values
  if (coords.length !== 2) {
    return false;
  }

  // Convert to numbers
  const lat = parseFloat(coords[0]);
  const lng = parseFloat(coords[1]);

  // Check if values are valid numbers
  if (isNaN(lat) || isNaN(lng)) {
    return false;
  }

  // Validate ranges:
  // Latitude: -90 to 90
  // Longitude: -180 to 180
  return lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180;
}
